import { RoutePath } from "@src/interfaces";
import { Chain } from "@src/models";
import { useNavigate } from "react-router-dom";

type Props = { chain?: Chain; disabled?: boolean };

export const PickChainButtton = ({ chain, disabled = false }: Props) => {
  const navigate = useNavigate();

  return (
    <button
      className={`w-[30px] h-[30px] rounded-lg flex items-center justify-center ${
        disabled ? "bg-background_primary" : "bg-card_bg"
      }`}
      onClick={() => {
        navigate(RoutePath.PickChain);
      }}
    >
      <img
        src={chain?.image}
        alt={chain?.name}
        className="w-4 h-4 rounded-full"
      />
    </button>
  );
};
